import { createAction, props } from '@ngrx/store';
import { PostOfferBillingInformation } from '../models/perm-post-offer-billing-information.model';
import { PermanentCandidateItemModel } from 'src/app/shared/models/permanent-candidate-item.model';

export const openPermOfferBillingUpdateModalFromGrid = createAction(
    '[Perm Post Offer Billing Update Modal Component] Open Perm Post Offer Billing Update Modal',
    props<{ model: PermanentCandidateItemModel }>()
);

export const updatePermPostOfferBillingInfo = createAction(
    '[Perm Post Offer Billing Update Modal Component] Update Perm Post Offer Billing Info',
    props<{ model: PostOfferBillingInformation }>()
);

export const updatePermPostOfferBillingInfoSuccess = createAction(
    '[Perm Post Offer Billing Update Modal API] Update Perm Post Offer Billing Info Success',
    props<{ model: PostOfferBillingInformation }>()
);

export const updatePermPostOfferBillingInfoFailure = createAction(
    '[Perm Post Offer Billing Update Modal API] Update Perm Post Offer Billing Info Failure',
    props<{ error: any }>()
);

export const cancelPermPostOfferBillingInfoModal = createAction(
    '[Perm Post Offer Billing Update Modal Component] Cancel Perm Post Offer Billing Update Modal'
);

export const loadPostOfferBillingUpdateModal = createAction(
    '[Perm Post Offer Billing Update Modal Component] Load Perm Post Offer Billing Update Modal'
);

export const clearPostOfferBillingState = createAction(
    '[Perm Post Offer Billing Update Modal Component] Clear Post Offer billing State'
);
